import React, { FC } from 'react';
import { Text, View } from 'react-native';

import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';

import {
  RANK_BADGE_COLORS,
  ROW_LAYOUT,
} from '@v2/pages/dashboard/common/constants/rows';
import type {
  Rank,
  RankBadgeVariant,
} from '@v2/pages/dashboard/common/types/rows';

interface DashboardOverviewBottomBlockRowBadgeProps extends WithColor {
  rank: Rank;
  variant: RankBadgeVariant;
}

const DashboardOverviewBottomBlockRowBadge: FC<DashboardOverviewBottomBlockRowBadgeProps> = ({ C, rank, variant }) => {
  const { color, opacity } = RANK_BADGE_COLORS[variant][rank];

  return (
    <View
      style={{
        width: scale(ROW_LAYOUT.badge.size),
        height: scale(ROW_LAYOUT.badge.size),
        borderRadius: scale(ROW_LAYOUT.badge.radius),
        marginHorizontal: scale(ROW_LAYOUT.badge.marginHorizontal),
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <View
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          borderRadius: scale(ROW_LAYOUT.badge.radius),
          backgroundColor: C(color),
          opacity,
        }}
      />
      <Text style={[font['Caption Rounded'], { color: C('Background/Light/System') }]}>{rank}</Text>
    </View>
  );
};

export default ColorWrapper(DashboardOverviewBottomBlockRowBadge);
